import { render, staticRenderFns } from "./UploadFile1.vue?vue&type=template&id=47488c34&scoped=true"
import script from "./script?vue&type=script&lang=js&external"
export * from "./script?vue&type=script&lang=js&external"
import style0 from "./UploadFile1.vue?vue&type=style&index=0&id=47488c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47488c34",
  null
  
)

export default component.exports